import React from 'react';

function About() {
	return (
		<div className="body-content bg-fff pt-70l-110m-50s pb-40">

			<div className="panel large pt-20l-10s">
				<div className="grid-x">
					<div className="large-12 medium-12 small-12 cell text-left">
						<div className="font-source-sans font-size-20 font-weight-800 txt-dark-blue bb1-dark-blue uppercase pb-5">About</div>
					</div>
				</div>
			</div>

			<div className="panel large pt-20l-10s">
				<div className="grid-x bg-fafafa b1-ddd p-20l-10s">
					<div className="large-12 medium-12 small-12 cell">
						<div className="font-raleway font-size-18 font-weight-700 uppercase text-left hide-for-small-only">Consulting</div>
						<div className="font-raleway font-size-18 font-weight-700 uppercase text-center show-for-small-only">Consulting</div>
						<div className="font-raleway font-size-16l-14s font-weight-500 line-height-125per justify pt-20">
							Double Integration (DI) is an end-to-end software and web application development firm providing modern and mobile responsive websites, web apps, mobile apps, software components, calculation engines, algorithms, AI and ML that get results. Founded in 1996 with the vision of creating a company that would build solutions that made a difference. We are a small but agile team providing solutions for individuals, small businesses, and corporations. Through our technical expertise and experience we can design and develop your project to fit your needs and time line. We are passionate and take the extra steps to launch a successful project.
						</div>
					</div>
				</div>
			</div>
			<div className="panel large pt-20l-10s">
				<div className="grid-x bg-fafafa b1-ddd p-20l-10s">
					<div className="large-12 medium-12 small-12 cell">
						<div className="font-raleway font-size-18 font-weight-700 uppercase text-left hide-for-small-only">Expertise</div>
						<div className="font-raleway font-size-18 font-weight-700 uppercase text-center show-for-small-only">Expertise</div>
						<div className="font-raleway font-size-16l-14s font-weight-500 line-height-125per justify pt-20">
							DI's expertise includes Front-End, Back-End, Mobile, Calculation Engines, as well as 3rd-Party Integration. Combining strategic planning, requirements gathering, usability, creativity, and technology, DI transforms business objectives into compelling digital experiences. We strive to create the best user experience for our clients and their customers/users. Following a project launch, our clients experience some pretty impressive results. Greater brand awareness. Increased web-site traffic. Improved search result rankings. More ideal customer leads. The list goes on and on. for some time-to-market is the key, for others a consistent product platform is the most critical factor.
						</div>
					</div>
				</div>
			</div>
			<div className="panel large pt-20l-10s">
				<div className="grid-x bg-fafafa b1-ddd p-20l-10s">
					<div className="large-12 medium-12 small-12 cell">
						<div className="font-raleway font-size-18 font-weight-700 uppercase text-left hide-for-small-only">Methodology</div>
						<div className="font-raleway font-size-18 font-weight-700 uppercase text-center show-for-small-only">Methodology</div>
						<div className="font-raleway font-size-16l-14s font-weight-500 line-height-125per justify pt-20">
							DI's methodology is to be agile and adaptive. Each project has different critical factors, for some time-to-market is the key, for others a consistent product platform is the most critical factor. We adapt our methodology to your project by combining traditional planning-based methodologies with agile methodologies.
						</div>
					</div>
				</div>
			</div>

		</div>

	);
}

export default About;